import { Context, useContext } from 'react'
import { Ability, AbilityTuple, MongoQuery } from '@casl/ability'
import AbilityContext from '@components/blocks/Acl/Context'

export const useAcl = (): Ability => useContext(AbilityContext as Context<Ability<AbilityTuple, MongoQuery>>)
